import { IDDriverLookupLayout, IDEquipmentLookupLayout, IDShipperLookupLayout, IDShipToLookupLayout, IDShipViaLookupLayout } from "../../../common/lookups/Layouts/IdLayouts";
import { OMTransactionHeaderLayout } from "../../../common/lookups/Layouts/OMLayouts";

const HeaderLayout = [
    {
        "groupId": 1,
        "label": "", 
        "fields": [
            {
                "name": "FMTRIPNUMBER",
                "tableName": "OMTRANSACTIONHEADER",
                "ignoredblocalization": true,
                "label": "Trip Number",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_TRUCK",
                "tableName": "OMTRANSACTIONHEADER",
                "ignoredblocalization": true,
                "label": "Truck",
                "type": "lookup",
                "layout": IDEquipmentLookupLayout({ equipmenttype: 'P' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
               {
                "name": "TRUCKARRIVALDATETIME",
                "tableName": "OMTRANSACTIONHEADER",
                "ignoredblocalization": true,
                "label": "Arrival",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 2,
        "label": "", 
        "fields": [
            {
                "name": "R_DRIVER",
                "tableName": "OMTRANSACTIONHEADER",
                "ignoredblocalization": true,
                "label": "Driver",
                "type": "lookup",
                "layout": IDDriverLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_TRAILER",
                "tableName": "OMTRANSACTIONHEADER",
                "ignoredblocalization": true,
                "label": "Trailer",
                "type": "lookup",
                "layout": IDEquipmentLookupLayout({ equipmenttype: 'T', colName: "Trailer" }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            
            {
                "name": "ROWID",
                "tableName": "OMTRANSACTIONHEADER",
                "ignoredblocalization": true,
                "localizedField":"TRANSACTIONNUMBER",
                "label": "Transaction #",
                "type": "lookup",
                "layout": OMTransactionHeaderLayout,
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "", 
        "fields": [
            {
                "name": "R_FMSHIPPER",
                "tableName": "OMTRANSACTIONHEADER",
                "ignoredblocalization": true,
                "label": "Shipper",
                "type": "lookup",
                "layout": IDShipperLookupLayout({valueExpr:'id',displayExpr:'identityid'}),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_SHIPVIA",
                "tableName": "OMTRANSACTIONHEADER",
                "ignoredblocalization": true,
                "label": "Ship Via",
                "type": "lookup",
                "required": false,
                "layout": IDShipViaLookupLayout,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "", 
        "fields": [
            {
                "name": "SHIPPINGDATE",
                "tableName": "OMTRANSACTIONHEADER",
                "ignoredblocalization": true,
                "label": "Ship Date",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TRUCKDEPARTDATETIME",
                "tableName": "OMTRANSACTIONHEADER",
                "ignoredblocalization": true,
                "label": "Departure",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
];
export { HeaderLayout };